// extracted by mini-css-extract-plugin
export default {"result_body":"style_result_body__PdfEA","result_container":"style_result_container__JxdJU","table_body":"style_table_body__US6dC","pageTitle":"style_pageTitle__Asiu1"};